import { api } from "@/services/api"
import { useQuery } from "@tanstack/react-query"
import { groupActivitiesByWeekday } from "../entities/groupActivitiesByWeekday"

interface GetActivityParams {
  startDate?: string
  endDate?: string
  userWeeklyObjectiveId?: string
}

export default function useGetActivities(values: GetActivityParams = {}) {
  const query = useQuery({
    queryKey: ["study-get-activities"],
    queryFn: async () => {
      const data = await api.cronos.activities.get(values)
      const result = groupActivitiesByWeekday(data.data.description)
      return result
    },
    refetchOnWindowFocus: false,
  })

  return query
}
